<template>
  <div class="main-content about">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Tentang Kami</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about-content">
      <div class="container about-detail-container">
        <div class="section-content">
          <div class="row">
            <div class="col-md-5">
              <img v-bind:src="image" alt class="img-about" />
            </div>
            <div class="col-md-7 mt-xs-30">
              <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
              <div v-else v-html="content"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="bg-silver-light service-container">
      <div class="container">
        <div class="section-title text-center">
          <div class="row">
            <div class="col-md-12">
              <h2 class="text-uppercase mt-0 line-height-1">Profile Rumah Sakit UII</h2>
            </div>
          </div>
        </div>
        <div class="section-content mt-30">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 mb-sm-20 mb-20">
              <div class="icon-box iconbox-theme-colored2 left media p-0">
                <a href="#" class="icon icon-bordered icon-circled media-left pull-left">
                  <i class="fa fa-stethoscope text-theme-colored"></i>
                </a>
                <div class="media-body">
                  <h3 class="media-heading heading">Direktur Utama</h3>
                  <p>dr. Widodo Wirawan, MPH</p>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 mb-sm-20 mb-20">
              <div class="icon-box iconbox-theme-colored2 left media p-0">
                <a href="#" class="icon icon-bordered icon-circled media-left pull-left">
                  <i class="fa fa-stethoscope text-theme-colored"></i>
                </a>
                <div class="media-body">
                  <h3 class="media-heading heading">Direktur Utama</h3>
                  <p>dr. Widodo Wirawan, MPH</p>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 mb-sm-20 mb-20">
              <div class="icon-box iconbox-theme-colored2 left media p-0">
                <a href="#" class="icon icon-bordered icon-circled media-left pull-left">
                  <i class="fa fa-stethoscope text-theme-colored"></i>
                </a>
                <div class="media-body">
                  <h3 class="media-heading heading">Direktur Utama</h3>
                  <p>dr. Widodo Wirawan, MPH</p>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 mb-sm-20 mb-20">
              <div class="icon-box iconbox-theme-colored2 left media p-0">
                <a href="#" class="icon icon-bordered icon-circled media-left pull-left">
                  <i class="fa fa-stethoscope text-theme-colored"></i>
                </a>
                <div class="media-body">
                  <h3 class="media-heading heading">Direktur Utama</h3>
                  <p>dr. Widodo Wirawan, MPH</p>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 mb-sm-20 mb-20">
              <div class="icon-box iconbox-theme-colored2 left media p-0">
                <a href="#" class="icon icon-bordered icon-circled media-left pull-left">
                  <i class="fa fa-stethoscope text-theme-colored"></i>
                </a>
                <div class="media-body">
                  <h3 class="media-heading heading">Direktur Utama</h3>
                  <p>dr. Widodo Wirawan, MPH</p>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 mb-sm-20 mb-20">
              <div class="icon-box iconbox-theme-colored2 left media p-0">
                <a href="#" class="icon icon-bordered icon-circled media-left pull-left">
                  <i class="fa fa-stethoscope text-theme-colored"></i>
                </a>
                <div class="media-body">
                  <h3 class="media-heading heading">Direktur Utama</h3>
                  <p>dr. Widodo Wirawan, MPH</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>-->

    <!-- <section class="bg-silver-yellow service-container">
      <div class="container">
        <div class="section-title text-center">
          <div class="row">
            <div class="col-md-12">
              <h2 class="text-uppercase mt-0 line-height-1">Tagline RS UII</h2>
              <p>Leading Service & Excellent Hospitality</p>
            </div>
          </div>
        </div>
      </div>
    </section>-->
  </div>
</template>

<script>
import api from "../services/api";

export default {
  name: "About",
  data() {
    return {
      show_loading: true,
      content: "",
      image: "",
    };
  },
  metaInfo() {
    return {
      title: "Tentang Kami",
      meta: [
        { charset: "utf-8" },
        { property: "og:site_name", content: "RSUII Website" },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "rsuii.co.id" },
        { property: "og:description", content: "RSUII Tentang Kami" },
        {
          property: "og:title",
          vmid: "og:title",
          content: "RSUII Tentang Kami",
        },
        {
          vmid: "description",
          name: "description",
          content: this.content.replace(/<[^>]*>?/gm, ""),
        },
        {
          vmid: "keywords",
          name: "keywords",
          content: "janji,appointment,layanan,rsuii,uii,universitas",
        },
      ],
    };
  },
  mounted() {
    this.getAbout();
  },
  methods: {
    getAbout() {
      api.post(api.route.get.page, { slug: "about-us" }).then((res) => {
        let status = res.status;
        if (status) {
          let content = res.content;
          let data = res.data;
          let dataJson = JSON.parse(data.meta);

          this.show_loading = false;
          this.content = data.content;
          this.image = dataJson.meta_picture;
        }
      });
    },
  },
};
</script>
<style>
.img-about {
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AboutUs.vue